// extracted by mini-css-extract-plugin
module.exports = {"odawa":"_0c5ff79","regulatoryText":"_6af4f27"};